import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./i18n/index.js";
import { App } from "./app/app.js";
import "./styles.css";

const rootElement = document.querySelector<HTMLElement>("#root");
if (rootElement === null) {
  throw new Error("Web root element is missing.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
